import DeleteConsultingCompanyContactContainer from "./DeleteConsultingCompanyContactContainer";
export default DeleteConsultingCompanyContactContainer;
